import { render, staticRenderFns } from "./ServiceAvailability.vue?vue&type=template&id=34745bd8&"
import script from "./ServiceAvailability.vue?vue&type=script&lang=js&"
export * from "./ServiceAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports